import React, { Component } from "react";

import Modal from "../../modal";

class ModalButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    _showModal = (e) => {
        if (e.altKey) {
            return;
        }

        this.setState({
            showModal: true,
        });
    };
    _closeModal = () => {
        this.setState({
            showModal: false,
        });
    };

    render() {
        return (
            <div>
                <button
                    className="button"
                    aria-label={this.props.name}
                    onClick={this._showModal}
                    disabled={this.props.disabled}
                >
                    {this.props.text}
                </button>
                <Modal
                    show={this.state.showModal}
                    onClose={this._closeModal}
                    cssClass={this.props.cssClass}
                >
                    {this.props.children}
                </Modal>
            </div>
        );
    }
}

export default ModalButton;
